import React from 'react';
import { CerebrumxTab } from './CerebrumxTab';
import { diagnosticsSections } from './diagnosticsRows';
import { energySections } from './energyRows';
import { liveSections } from './liveRows';
import { locationSections } from './locationRows';
import { TelemetrySamplesTable } from './TelemetrySamplesTable';
import { TirePressureGrid } from './TirePressureGrid';
import { vehicleSections } from './vehicleRows';

/**
 * Always drawn (deviation from z1-ui-main, requested 2026-10-01): without a
 * `cx_tires` block the silhouette and tiles render greyed out with a
 * "no tire data" note, so the layout is the same for every event.
 */
const tiresBlock = (view, ctx) => <TirePressureGrid tires={view.tires} ctx={ctx} />;

const samplesBlock = (view, ctx) => {
	if (view.samples === undefined || view.samples.length === 0) return null;
	return <TelemetrySamplesTable samples={view.samples} speedUnit={view.speed?.unit} ctx={ctx} />;
};

/** Live: event, motion, distances, environment, last reported. */
export const CerebrumxLiveTab = ({ record }) => <CerebrumxTab record={record} build={liveSections} />;

/** Energy: fuel, charge, 12 V battery. */
export const CerebrumxEnergyTab = ({ record }) => <CerebrumxTab record={record} build={energySections} />;

/** Diagnostics: tires around the silhouette, then the engine block. */
export const CerebrumxDiagnosticsTab = ({ record }) => (
	<CerebrumxTab record={record} build={diagnosticsSections} before={tiresBlock} />
);

/** Location: the fix and its quality, then the breadcrumbs recorded since the previous event. */
export const CerebrumxLocationTab = ({ record }) => (
	<CerebrumxTab record={record} build={locationSections} after={samplesBlock} />
);

/** Vehicle: identity of the unit and of this message. */
export const CerebrumxVehicleTab = ({ record }) => <CerebrumxTab record={record} build={vehicleSections} />;
